/**
 * @generated SignedSource<<aeb68ef0fa3334b0f53606b0d5bcc4ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetRoutineOverviewListItem_routine$data = {
  readonly id: string;
  readonly ownerTeam: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly title: string;
  readonly " $fragmentType": "WidgetRoutineOverviewListItem_routine";
};
export type WidgetRoutineOverviewListItem_routine$key = {
  readonly " $data"?: WidgetRoutineOverviewListItem_routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverviewListItem_routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetRoutineOverviewListItem_routine",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "ownerTeam",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "ed05bbf65f704ec2e81a17a97a912269";

export default node;
